// HomeSection.js
// Page-level section header (used above Explore and Recent), with an
// optional leading icon and a right-aligned aside node.
import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { homeColors } from "../homeTheme";

const HomeSection = ({
  title,
  icon = null,
  aside = null,
  headerZIndex = null,
  headerTestID = null,
  isDarkMode = false,
  children,
}) => {
  const colors = homeColors(isDarkMode);

  return (
    <View style={styles.wrap}>
      <View
        style={[
          styles.headerRow,
          headerZIndex != null ? { position: "relative", zIndex: headerZIndex } : null,
        ]}
        testID={headerTestID}
      >
        <View style={styles.titleRow}>
          {icon ? (
            <MaterialCommunityIcons
              name={icon}
              size={18}
              color={colors.textSecondary}
              style={styles.icon}
            />
          ) : null}
          <Text style={[styles.title, { color: colors.textPrimary }]}>{title}</Text>
        </View>
        {aside}
      </View>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { marginBottom: 12 },
  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  titleRow: { flexDirection: "row", alignItems: "center", gap: 8 },
  icon: { marginRight: 2 },
  title: { fontSize: 15, fontWeight: "700" },
});

export default HomeSection;
